<template>
  <CRow>
    <CCol>
      <div class="form-group" v-bind:class="{ error: errors.subject_id }">
        <label>Seri Tryout</label>
        <input type="text" class="form-control series-input" v-model="data.label" />
        <message-container :data="errors.label" />
      </div>
      <div class="form-group" v-bind:class="{ error: errors.subject_id }">
        <label>Jalur Masuk</label>
        <entrance-major-multi
          @input="changeEntranceMajor"
          v-model="data.entrance_majors"
          class="series-input"
        />
        <message-container :data="errors.entrance_major_id" />
      </div>
    </CCol>
    <CCol>
      <div class="form-group" v-bind:class="{ error: errors.average }">
        <label>Periode</label>
        <VueCtkDateTimePicker
          v-model="data.periode"
          :range="true"
          :no-shortcuts="true"
          input-size="sm"
          color="#3c4b64"
          :overlay="true"
          format="YYYY-MM-DD"
          formatted="DD MMM YYYY"
          locale="id"
          label="Periode"
        />
        <message-container :data="errors.duration" />
      </div>
      <div class="form-group" v-bind:class="{ error: errors.subject_id }">
        <label>Kelompok Program Study</label>
        <study-program-group-selector v-model="data.study_program_group"/>
        <message-container :data="errors.study_program_group" />
      </div>
    </CCol>
    <CCol col="3">
      <div class="form-group" v-bind:class="{ error: errors.subject_id }">
        <label>Durasi Pengerjaan (Menit)</label>
        <input type="number" class="form-control series-input" v-model="data.duration" />
        <message-container :data="errors.price" />
      </div>
      <div class="form-group" v-bind:class="{ error: errors.subject_id }">
        <label>Harga</label>
        <input type="text" class="form-control series-input" v-model="data.price" />
        <message-container :data="errors.price" />
      </div>
    </CCol>
    <CCol col="2">
      <div class="form-group" v-bind:class="{ error: errors.subject_id }">
        <label>.</label>
        <div class="form-group">
          <button class="btn btn-success" v-if="!data.id" @click="save">
            Save
          </button>
          <button class="btn btn-success" v-if="data.id" @click="update">
            Update
          </button>
        </div>
      </div>
    </CCol>
  </CRow>
</template>
<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import MessageContainer from "../../components/MessageContainer.vue";
import EntranceMajorMulti from "../../components/EntranceMajorMulti.vue";
import { HTTPAUTH } from "../../lib/httplib";
import { showErrorMessage } from '../../lib/helpers';
import StudyProgramGroupSelector from '../../components/StudyProgramGroupSelector.vue';
export default {
  components: {
    VueCtkDateTimePicker,
    MessageContainer,
    EntranceMajorMulti,
    StudyProgramGroupSelector,
  },
  props: ["data"],
  data() {
    return {
      errors: [],
    };
  },
  methods: {
    changeDate(date) {
      this.data.period = date;
    },
    changeEntranceMajor(v) {
      this.data.entrance_majors = v;
    },
    save() {
      if (this.data.periode) {
        this.data.effective_date = this.data.periode.start;
        this.data.effective_until = this.data.periode.end;
      }
      HTTPAUTH.post(`/api/v1/admin/series`, this.data)
        .then((res) => {
          this.$toasted.success("Berhasil disimpan").goAway();
          this.data = res.data.data;
          this.action(this.data.id);
          this.$router.push({ params: { id: this.data.id } });
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    update() {
      if (this.data.periode) {
        this.data.effective_date = this.data.periode.start;
        this.data.effective_until = this.data.periode.end;
      }
      if (this.data.entrance_major) {
        this.data.entrance_major_id = this.data.entrance_major.id;
      }
      HTTPAUTH.put(`/api/v1/admin/series/${this.data.id}`, this.data)
        .then((res) => {
          const data = res.data.data;
          this.action(data.id);
          this.$toasted.success("Berhasil disimpan").goAway();
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    action(id) {
      this.$emit("update", id);
    },
  },
};
</script>